

import axios from 'axios';
import { API_URL } from '../config/api';

const getAuthHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('admin_token')}`,
  'Content-Type': 'application/json',
  Accept: 'application/json',
});

export const evalApi = {
  //  Admin 

  /** Liste toutes les sessions */
  getSessions: () =>
    axios.get(`${API_URL}/eval/sessions`, { headers: getAuthHeaders() }),

  /** Détail d'une session avec tous les avis */
  getSession: (id) =>
    axios.get(`${API_URL}/eval/sessions/${id}`, { headers: getAuthHeaders() }),

  /** Créer une nouvelle session d'évaluation */
  createSession: (data) =>
    axios.post(`${API_URL}/eval/sessions`, data, { headers: getAuthHeaders() }),

  /** Toggle QR actif/inactif */
  toggleQR: (id) =>
    axios.patch(`${API_URL}/eval/sessions/${id}/toggle-qr`, {}, { headers: getAuthHeaders() }),

  /** Clôturer manuellement */
  terminer: (id) =>
    axios.patch(`${API_URL}/eval/sessions/${id}/terminer`, {}, { headers: getAuthHeaders() }),

  /** Polling compte à rebours */
  getCountdown: (id) =>
    axios.get(`${API_URL}/eval/sessions/${id}/countdown`, { headers: getAuthHeaders() }),

  /** Supprimer une session */
  deleteSession: (id) =>
    axios.delete(`${API_URL}/eval/sessions/${id}`, { headers: getAuthHeaders() }),

  //  Public (participants) 

  /** Charger les infos de la session via token (démarre le countdown) */
  getPublicSession: (token) =>
    axios.get(`${API_URL}/eval/public/${token}`),

  /** Soumettre un avis */
  soumettre: (token, data) =>
    axios.post(`${API_URL}/eval/public/${token}/soumettre`, data),
};

/** Construit le lien public à partir d'un token */
export const buildEvalLink = (token) =>
  `${window.location.origin}/eval/${token}`;